module.exports = __webpack_public_path__ + "static/media/walk.43f0bf77.fbx";